import useHistoryRaw from './useHistory';
export const useHistory = useHistoryRaw;
export default useHistoryRaw;
